<template>
  <div
    :class="['email-component', 'button-component', { selected }]"
    @click="handleClick"
  >
    <div class="component-content" :style="getContainerStyles()">
      <a
        :style="getButtonStyles()"
        class="email-button"
      >
        {{ componentData.content }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonComponent',
  props: ['componentData', 'selected'],
  methods: {
    handleClick() {
      this.$emit('click')
    },

    getContainerStyles() {
      const alignment = this.componentData.alignment || 'center'
      return {
        textAlign: alignment,
        margin: `${this.componentData.styles?.marginTop || '16px'} 0 ${this.componentData.styles?.marginBottom || '16px'} 0`
      }
    },

    getButtonStyles() {
      const size = this.componentData.size || 'medium'
      const sizeStyles = this.getSizeStyles(size)

      return {
        ...this.componentData.styles,
        ...sizeStyles,
        display: 'inline-block',
        textDecoration: 'none',
        border: 'none',
        cursor: 'pointer',
        fontWeight: '500',
        borderRadius: this.componentData.styles?.borderRadius || '4px', // Ensure border radius is applied
        transition: 'all 0.2s ease'
      }
    },

    getSizeStyles(size) {
      const sizeMap = {
        small: {
          padding: '8px 16px',
          fontSize: '14px',
          lineHeight: '1.4'
        },
        medium: {
          padding: '12px 24px',
          fontSize: '16px',
          lineHeight: '1.5'
        },
        large: {
          padding: '16px 32px',
          fontSize: '18px',
          lineHeight: '1.5'
        }
      }

      return sizeMap[size] || sizeMap.medium
    }
  }
}
</script>

<style scoped>
.button-component {
  min-height: 60px;
  display: flex;
  align-items: center;
}

.component-content {
  width: 100%;
}

.email-button {
  font-family: inherit;
  white-space: nowrap;
}

.email-button:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
</style>
